import { Flex, Box } from "@chakra-ui/react";
import { FunnelComponentProps } from "../../funnel/types";
import { BundlePurchaseData } from "./BundlePurchaseData";
import { useEffect, useRef } from "react";
import { useIsVisible } from "../../../hooks/useIsVisible";
import { EventTypes } from "../../../screens/root/api/eventsApi";
import { Bundle } from "../../../types";
import { BundleImageStack } from "../../cards/components/BundleImageStack";
import { PurchaseBundleModalFooter } from "./PurchaseBundleModalFooter";
import { useMobileBreakpoint } from "../../../utils/useBreakpoints";

export interface PurchaseBundleModalBodyProps extends FunnelComponentProps {
  bundle?: Bundle;
}

export function PurchaseBundleModalBody(
  funnelProps: PurchaseBundleModalBodyProps,
) {
  const { bundle, sendEvent } = funnelProps;
  const isMobile = useMobileBreakpoint();
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useIsVisible(ref, 0.5);
  const alreadyTracked = useRef(false);

  useEffect(() => {
    if (sendEvent && isVisible && !alreadyTracked.current) {
      sendEvent(EventTypes.viewed_bundle_offer);
      alreadyTracked.current = true;
    }
  }, [isVisible]);

  if (!bundle) return null;

  return (
    <Flex flexDirection="column" gap="24px" width="100%" padding="24px" ref={ref}>
      <Flex
        flexDirection={isMobile ? "column" : "row"}
        width="fit-content"
        alignSelf="center"
        alignItems="center"
        gap={6}
      >
        <BundleImageStack items={bundle.items || []} layout="list" />
        <BundlePurchaseData
          bundle={bundle}
          alignItems={isMobile ? "center" : "start"}
        />
      </Flex>
      <Box width="100%" height="1px" background="transparent.white.10" />
      <PurchaseBundleModalFooter bundle={bundle} {...funnelProps} />
    </Flex>
  );
}
